import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle } from '@angular/platform-browser';
import { ImageUtils } from '../../../../../common/utils/image-utils';

interface Styles {
  name: string;
  content: string;
  loaded: boolean;
}

export interface StylesLoaded {
  [id: string]: Styles;
}

const styleStore: Styles[] = [
  // { name: 'test', content: 'h1 { color:red}', loaded: false },
];

@Component({
  selector: 'app-display-hero-slide',
  template: `
    @if (displayInTable === 'form') {
      <div class="hero-content-adjust">
        <div [innerHTML]="innerHTML" [ngClass]="'slide-' + this.slideId"></div>
        @if (name) {
          <p class="hero-info">Name: {{ name }}</p>
        }
      </div>
    }
    @if (displayInTable === 'table') {
      <div class="hero-slide-table">
        <div [innerHTML]="innerHTML" [ngClass]="'slide-' + this.slideId"></div>
        @if (name) {
          <p class="info">Name: {{ name }}</p>
        }
      </div>
    }
  `,
  styleUrls: ['./display-hero-slide.component.scss'],
  standalone: false,
})
export class DisplayHeroSlideComponent implements OnInit, OnDestroy {
  @Input() html: string;

  @Input() css: string;

  @Input() name: string;

  @Input() slideId: number;

  @Input() displayInTable: string;

  innerHTML: SafeHtml = '';

  innerCSS: SafeStyle = '';

  private styles: StylesLoaded = {};

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnInit() {
    let strippedHtml = '<div>Heh! no html!</div>';
    if (this.html !== undefined && this.html !== null) {
      strippedHtml = this.html.replace('src="./assets', `src="${ImageUtils.getCloudURL()}/assets`);
      if (strippedHtml.indexOf('<video') > 0) {
        strippedHtml = '<div>[contains a video]</div>';
      }
      if (strippedHtml.indexOf('<iframe') > 0) {
        strippedHtml = '<div>[contains iframe]</div>';
      }
    }
    let strippedCss = '';
    if (this.css !== undefined && this.css !== null) {
      strippedCss = this.css.replace('src="./assets', `src="${ImageUtils.getCloudURL()}/assets`);
    }

    this.innerHTML = this.domSanitizer.bypassSecurityTrustHtml(strippedHtml);
    this.innerCSS = this.domSanitizer.bypassSecurityTrustStyle(`.slide {${strippedCss}}`);
    this.loadStyle(`${this.slideId}`, strippedCss);
  }

  ngOnDestroy() {}

  loadStyle(name: string, content: string): Promise<any> {
    if (this.styles[name] === undefined) {
      const newStyle = {
        loaded: false,
        content,
        name,
      } as Styles;
      this.styles[name] = newStyle;
    }
    return this.loadStyleByName(name);
  }

  // load only one style.
  loadStyleByName(name: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      // resolve if already loaded
      if (this.styles[name] !== undefined && this.styles[name].loaded) {
        resolve({ name, loaded: true, status: 'Already Loaded' });
      } else {
        // load style
        const style = document.createElement('style');
        style.type = 'text/css';

        style.appendChild(document.createTextNode(this.styles[name].content));
        style.onload = () => {
          this.styles[name].loaded = true;
          resolve({ name, loaded: true, status: 'Loaded' });
        };
        style.onerror = (error: any) => {
          resolve({ name, loaded: false, status: 'Loaded' });
        };
        document.getElementsByTagName('head')[0].appendChild(style);
      }
    });
  }
}
